import { combineReducers } from 'redux';

import { registerReducer } from '../../utils/reducerUtils';
import {SET_AQL_LIMIT_MAJOR, SET_AQL_LIMIT_MINOR, SET_INSPECTION_LEVEL, SET_MIN_ORDER_QTY} from '../types';

const sampleSizeLettersInOrder = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R'];

export const ORDER_QTY_LEVELS = [
  { min: 2,      max: 8,        I: 'A', II: 'A', III: 'B', S1: 'A', S2: 'A', S3: 'A', S4: 'A' },
  { min: 9,      max: 15,       I: 'A', II: 'B', III: 'C', S1: 'A', S2: 'A', S3: 'A', S4: 'A' },
  { min: 16,     max: 25,       I: 'B', II: 'C', III: 'D', S1: 'A', S2: 'A', S3: 'B', S4: 'B' },

  { min: 26,     max: 50,       I: 'C', II: 'D', III: 'E', S1: 'A', S2: 'B', S3: 'B', S4: 'C' },
  { min: 51,     max: 90,       I: 'C', II: 'E', III: 'F', S1: 'B', S2: 'B', S3: 'C', S4: 'C' },
  { min: 91,     max: 150,      I: 'D', II: 'F', III: 'G', S1: 'B', S2: 'B', S3: 'C', S4: 'D' },

  { min: 151,    max: 280,      I: 'E', II: 'G', III: 'H', S1: 'B', S2: 'C', S3: 'D', S4: 'E' },
  { min: 281,    max: 500,      I: 'F', II: 'H', III: 'J', S1: 'B', S2: 'C', S3: 'D', S4: 'E' },
  { min: 501,    max: 1200,     I: 'G', II: 'J', III: 'K', S1: 'C', S2: 'C', S3: 'E', S4: 'F' },

  { min: 1201,   max: 3200,     I: 'H', II: 'K', III: 'L', S1: 'C', S2: 'D', S3: 'E', S4: 'G' },
  { min: 3201,   max: 10000,    I: 'J', II: 'L', III: 'M', S1: 'C', S2: 'D', S3: 'F', S4: 'G' },
  { min: 10001,  max: 35000,    I: 'K', II: 'M', III: 'N', S1: 'C', S2: 'D', S3: 'F', S4: 'H' },

  { min: 35001,  max: 150000,   I: 'L', II: 'N', III: 'P', S1: 'D', S2: 'E', S3: 'G', S4: 'J' },
  { min: 150001, max: 500000,   I: 'M', II: 'P', III: 'Q', S1: 'D', S2: 'E', S3: 'G', S4: 'J' },
  { min: 500001, max: Infinity, I: 'N', II: 'Q', III: 'R', S1: 'D', S2: 'E', S3: 'H', S4: 'K' },
];

export const INSPECTION_LEVELS = {
  I:    'General I',
  II:   'General II',
  III:  'General III',
  S1:   'Special 1',
  S2:   'Special 2',
  S3:   'Special 3',
  S4:   'Special 4',
};

export const SAMPLE_SIZE_PLANS = {
  A: { sampleSize: 2,    '0.065': 'L', '0.10': 'K', '0.15': 'J', '0.25': 'H', '0.40': 'G', '0.65': 'F', '1.0': 'E', '1.5': 'D', '2.5': 'C', '4.0': 'B', '6.5':  0 },
  B: { sampleSize: 3,    '0.065': 'L', '0.10': 'K', '0.15': 'J', '0.25': 'H', '0.40': 'G', '0.65': 'F', '1.0': 'E', '1.5': 'D', '2.5': 'C', '4.0': 0,   '6.5': 'A' },
  C: { sampleSize: 5,    '0.065': 'L', '0.10': 'K', '0.15': 'J', '0.25': 'H', '0.40': 'G', '0.65': 'F', '1.0': 'E', '1.5': 'D', '2.5':  0,  '4.0': 'B', '6.5': 'D' },

  D: { sampleSize: 8,    '0.065': 'L', '0.10': 'K', '0.15': 'J', '0.25': 'H', '0.40': 'G', '0.65': 'F', '1.0': 'E', '1.5':  0,  '2.5': 'C', '4.0': 'E', '6.5':  1 },
  E: { sampleSize: 13,   '0.065': 'L', '0.10': 'K', '0.15': 'J', '0.25': 'H', '0.40': 'G', '0.65': 'F', '1.0':  0,  '1.5': 'D', '2.5': 'F', '4.0': 1,   '6.5':  2 },
  F: { sampleSize: 20,   '0.065': 'L', '0.10': 'K', '0.15': 'J', '0.25': 'H', '0.40': 'G', '0.65':  0,  '1.0': 'E', '1.5': 'G', '2.5':  1,  '4.0': 2,   '6.5':  3 },

  G: { sampleSize: 32,   '0.065': 'L', '0.10': 'K', '0.15': 'J', '0.25': 'H', '0.40':  0,  '0.65': 'F', '1.0': 'H', '1.5':  1,  '2.5':  2,  '4.0': 3,   '6.5':  5 },
  H: { sampleSize: 50,   '0.065': 'L', '0.10': 'K', '0.15': 'J', '0.25':  0,  '0.40': 'G', '0.65': 'J', '1.0':  1,  '1.5':  2,  '2.5':  3,  '4.0': 5,   '6.5':  7 },
  J: { sampleSize: 80,   '0.065': 'L', '0.10': 'K', '0.15':  0,  '0.25': 'H', '0.40': 'K', '0.65':  1,  '1.0':  2,  '1.5':  3,  '2.5':  5,  '4.0': 7,   '6.5':  10 },

  K: { sampleSize: 125,  '0.065': 'L', '0.10':  0,  '0.15': 'J', '0.25': 'L', '0.40':  1,  '0.65':  2,  '1.0':  3,  '1.5':  5,  '2.5':  7,  '4.0': 10,  '6.5':  14 },
  L: { sampleSize: 200,  '0.065':  0,  '0.10': 'K', '0.15': 'M', '0.25':  1,  '0.40':  2,  '0.65':  3,  '1.0':  5,  '1.5':  7,  '2.5':  10, '4.0': 14,  '6.5':  21 },
  M: { sampleSize: 315,  '0.065': 'L', '0.10': 'N', '0.15':  1,  '0.25':  2,  '0.40':  3,  '0.65':  5,  '1.0':  7,  '1.5':  10, '2.5':  14, '4.0': 21,  '6.5': 'L' },

  N: { sampleSize: 500,  '0.065': 'P', '0.10':  1,  '0.15':  2,  '0.25':  3,  '0.40':  5,  '0.65':  7,  '1.0':  10, '1.5':  14, '2.5':  21, '4.0': 'M', '6.5': 'L' },
  P: { sampleSize: 800,  '0.065':  1,  '0.10':  2,  '0.15':  3,  '0.25':  5,  '0.40':  7,  '0.65':  10, '1.0':  14, '1.5':  21, '2.5': 'N', '4.0': 'M', '6.5': 'L' },
  Q: { sampleSize: 1250, '0.065':  2,  '0.10':  3,  '0.15':  5,  '0.25':  7,  '0.40':  10, '0.65':  14, '1.0':  21, '1.5': 'P', '2.5': 'N', '4.0': 'M', '6.5': 'L' },
  R: { sampleSize: 2000, '0.065':  3,  '0.10':  5,  '0.15':  7,  '0.25':  10, '0.40':  14, '0.65':  21, '1.0': 'R', '1.5': 'P', '2.5': 'N', '4.0': 'M', '6.5': 'L' },
};

export const AQL_LIMITS = [
  '0.065',
  '0.10',
  '0.15',
  '0.25',
  '0.40',
  '0.65',
  '1.0',
  '1.5',
  '2.5',
  '4.0',
  '6.5',
];

function sampleSizeAndAllowedDefectsFor(sampleSizeLetter, aqlLimit) {
  const sampleSizePlan = SAMPLE_SIZE_PLANS[sampleSizeLetter];

  if (typeof sampleSizePlan[aqlLimit] === 'string')
    return sampleSizeAndAllowedDefectsFor(sampleSizePlan[aqlLimit], aqlLimit);

  return {
    allowed: sampleSizePlan[aqlLimit],
    sampleSize: sampleSizePlan.sampleSize,
    sampleSizeLetter,
  };
}

function allowedDefectsFor(sampleSizeLetter, aqlLimit) {
  const sampleSizePlan = SAMPLE_SIZE_PLANS[sampleSizeLetter];

  if (typeof sampleSizePlan[aqlLimit] === 'string') {
    const idx = sampleSizeLettersInOrder.indexOf(sampleSizeLetter);

    return idx > 0 ? allowedDefectsFor(sampleSizeLettersInOrder[idx-1], aqlLimit) : 0;
  }

  return sampleSizePlan[aqlLimit];
}

function calculate(inspectionLevel, minOrderQty, aqlLimitMajor, aqlLimitMinor) {
  // Find the lot size range that applied to the orderQty
  const orderQty = ORDER_QTY_LEVELS.find(({ min }) => min === parseInt(minOrderQty));

  // Find the base sample size letter for the AQL level
  // (it might change if the sample size and AQL level is not a valid combination)
  const baseSampleSizeLetter = orderQty[inspectionLevel];

  // Get the valid sample size and allowed number of defects for the major AQL level
  const { sampleSizeLetter, sampleSize, allowed } = sampleSizeAndAllowedDefectsFor(baseSampleSizeLetter, aqlLimitMajor);

  // Get the allowed number of defects for the minor AQL level, but don't change the
  // sample size, even if the combination is not valid, instead it will take the closest
  // previous number of allowed defects, based on lower sample sizes.
  const allowedMinor = allowedDefectsFor(sampleSizeLetter, aqlLimitMinor);

  return {
    allowedMajor: allowed,
    allowedMinor,
    sampleSize,
  };
}

const initialState = {
  aqlLimitMajor: '2.5',
  aqlLimitMinor: '4.0',
  inspectionLevel: 'II',
  minOrderQty: 3201,
  ...calculate('II', 3201, '2.5', '4.0'),
};

const aqlCalculatorReducer = registerReducer(initialState, {
  [SET_MIN_ORDER_QTY]: ({ aqlLimitMajor, aqlLimitMinor, inspectionLevel }, { minOrderQty }) => {
    return {
      minOrderQty,
      ...calculate(inspectionLevel, minOrderQty, aqlLimitMajor, aqlLimitMinor),
    };
  },

  [SET_INSPECTION_LEVEL]: ({ aqlLimitMajor, aqlLimitMinor, minOrderQty }, { inspectionLevel }) => {
    return {
      inspectionLevel,
      ...calculate(inspectionLevel, minOrderQty, aqlLimitMajor, aqlLimitMinor),
    };
  },

  [SET_AQL_LIMIT_MAJOR]: ({ aqlLimitMinor, inspectionLevel, minOrderQty }, { aqlLimitMajor }) => {
    return {
      aqlLimitMajor,
      ...calculate(inspectionLevel, minOrderQty, aqlLimitMajor, aqlLimitMinor),
    };
  },

  [SET_AQL_LIMIT_MINOR]: ({ aqlLimitMajor, minOrderQty, inspectionLevel }, { aqlLimitMinor }) => {
    return {
      aqlLimitMinor,
      ...calculate(inspectionLevel, minOrderQty, aqlLimitMajor, aqlLimitMinor),
    };
  },
});

const rootReducer = combineReducers({
  aqlCalculator: aqlCalculatorReducer,
});

export default rootReducer;